import React from 'react';
import theme from 'site-react/theme';
import { css, cx } from 'emotion';

import MaterialIcon from 'site-react/core/Icon/MaterialIcon';

const baseStyles = css`
  cursor: pointer;
  float: right;
`;

const menuStyles = css`
  text-align: center;
  font-size: ${theme.font.size.xxl};
  margin: 11px 24px 0 0;
`;

const closeStyles = css`
  color: ${theme.colors.white};
  font-size: ${theme.font.size.xl};
  margin-top: -5px;
`;

const leftStyles = css`
  float: left;
`;

const MobileNavIconMenu = (props) => (
  <MaterialIcon
    {...props}
    iconType="menu"
    className={cx(baseStyles, menuStyles)}
  />
);

const MobileNavIconClose = (props) => (
  <MaterialIcon
    {...props}
    iconType="close"
    className={cx(baseStyles, closeStyles)}
  />
);

const MobileNavIconBack = (props) => (
  <MaterialIcon
    {...props}
    iconType="keyboard_arrow_left"
    className={cx(baseStyles, closeStyles, leftStyles)}
  />
);

export { MobileNavIconMenu, MobileNavIconClose, MobileNavIconBack };
export default { MobileNavIconMenu, MobileNavIconClose, MobileNavIconBack };
